import React from 'react';
import { Row } from 'react-bootstrap';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Input } from 'v3/components';
import {
  SortableAnswerActions,
  SortableAnswerColContainer,
  SortableAnswerHandle,
  SortableAnswerInputWrap,
  SortableAnswerRemoveButton,
} from './styles';
import CheckBox from 'components/CheckBox';
import { LOGICAL_QUESTION_SLUG } from '../../shared/utils';

export function SortableAnswer({
  answer,
  index,
  setQuestion,
  question,
  handleRemoveAnswer,
  questionType,
  showCorrectOption,
  onToggleCorrect,
  errors,
}) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: answer?.id,
  });
  const style = {
    transition,
    transform: CSS.Translate.toString(transform),
  };
  const isLogicalQuestion = questionType?.slug === LOGICAL_QUESTION_SLUG;
  const actionsMinWidth = showCorrectOption
    ? isLogicalQuestion
      ? 170
      : 140
    : 52;

  function handleOnChange(value, index) {
    const updatedAnswers = question?.answers?.map((item, idx) => {
      if (idx === index) {
        return {
          ...item,
          description: value,
        };
      }
      return item;
    });
    setQuestion((old) => ({ ...old, answers: [...updatedAnswers] }));
  }

  return (
    <Row ref={setNodeRef} style={style} className="my-2">
      <SortableAnswerColContainer md={10} sm={12}>
        <SortableAnswerHandle {...attributes} {...listeners} title="Clique e arraste para ordenar">
          <svg viewBox="0 0 20 20" width="20" transform="rotate(90)">
            <path d="M7 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 2zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 14zm6-8a2 2 0 1 0-.001-4.001A2 2 0 0 0 13 6zm0 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 14z" />
          </svg>
        </SortableAnswerHandle>
        <SortableAnswerInputWrap>
          <Input
            value={answer?.description}
            onChange={e => handleOnChange(e.target.value, index)}
            disabled={isLogicalQuestion}
            placeholder={'Informe opção resposta'}
            error={errors?.[`question.answers[${index}].description`]}
          />
        </SortableAnswerInputWrap>
        <SortableAnswerActions style={{ minWidth: actionsMinWidth }}>
          {showCorrectOption && (
            <CheckBox
              label="Correta"
              labelStyle={{
                textTransform: 'capitalize',
                color: '#464E5F',
                marginBottom: 0,
                whiteSpace: 'nowrap',
                width: 'auto',
                columnGap: isLogicalQuestion ? '12px' : '8px',
              }}
              checked={answer?.isCorrect}
              value={answer?.isCorrect}
              onChange={() => onToggleCorrect(index)}
            />
          )}
          <SortableAnswerRemoveButton
            variant="error"
            icon="FaTrash"
            color="white"
            title="Remover alternativa"
            onClick={() => handleRemoveAnswer(index, question?.answers)}
            disabled={isLogicalQuestion}
          />
        </SortableAnswerActions>
      </SortableAnswerColContainer>
    </Row>
  );
}
